import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useBreakpoints } from "react-breakpoints-hook";

export default function MenuOptions({ options }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  let {
  xs,
  sm,
  md
} = useBreakpoints({
  xs: {
    min: 0,
    max: 360
  },
  sm: {
    min: 361,
    max: 960
  },
  md: {
    min: 961,
    max: 1400
  },
  lg: {
    min: 1401,
    max: null
  }
});

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const ITEM_HEIGHT = 48;
  return (
    <div>
      <IconButton
        style={{
          color: "var(--txt-color)",
          transform: `translateX(${md || sm || xs ? "-20px" : "0"})`,
        }}
        disableRipple
        disableTouchRipple
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: "20ch",
            backgroundColor: "var(--main-color)",
            color: "var(--txt-white)",
            "&:hover": {
              color: "var(--second-color)",
            },
          },
        }}
        style={{ background: "var(--m" }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {options.map((option, index) => (
          <MenuItem
            key={index}
            onClick={() => {
              handleClose();
              option.callback();
            }}
          >
            {option.value}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
